import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import _isUndefined from 'lodash/isUndefined';
import {treatmentTypes} from '../../../../../utils/skincareUtils';
import langUtils from '../../../../../utils/langUtils';

const getButton = btn =>
  btn && {
    ...btn,
    border: {
      ...btn.border,
      radius: `${btn.border.radius}px`,
    },
  };

const getIconUrl = icon => _get(icon, 'image.image');

const getPreviewList = list => {
  let newList = [];
  if (list.length > 0) {
    list.map(p => {
      if (p === 'dark_circle_v2') {
        newList.push('darkCircle');
        newList.push('darkCircle_v2');
      } else {
        newList.push(p);
      }
    });
    return {
      concernOrder: newList,
    };
  }
  return {
    concernOrder: [],
  };
};

export default {
  previewDevices: {
    phone: {
      width: 375,
      height: 667,
      zoom: 2.8,
    },
    mobile: {
      width: 375,
      height: 667,
      zoom: 2.8,
    },
    pad: {
      width: 768,
      height: 1024,
      zoom: 2.8,
    },
    padLandscape: {
      width: 1024,
      height: 768,
      zoom: 3,
    },
    desktop: {
      width: 700,
      height: 933,
      zoom: 1.65,
    },
  },
  toResultPreview: values => {
    const config = {
      languages: langUtils.getAppLangList().map(r => r.value),
      defaultLanguage: values.langs[0].page.defaultLanguage || 'enu',
      pages: [],
      preview: getPreviewList(
        _get(values, 'langs[0].preview.concernOrder', [])
      ),
    };
    const pages = [];
    config.languages.map(l => {
      values.langs.forEach(pageByLang => {
        const {
          header,
          body,
          buttonLayout,
          buttons,
          featureConfig,
          footer,
          skincareHtmlResult,
        } = pageByLang.page;
        if (_isUndefined(skincareHtmlResult) || _isUndefined(buttons))
          return {};
        if (pageByLang.default) config.defaultLanguage = 'enu';

        let copySkincareHtmlResult = _cloneDeep(skincareHtmlResult);

        const recommendSummary =
          _get(skincareHtmlResult, 'recommendSummary') || {};
        const routineRecommend =
          _get(skincareHtmlResult, 'routineRecommend') || {};
        const productRecommend =
          _get(skincareHtmlResult, 'productRecommend') || {};
        const treatmentRecommend =
          _get(skincareHtmlResult, 'treatmentRecommend') || {};

        // sync with APP values - spot and darkCircle
        const configDescription = {};
        const detectionDescription = _get(
          skincareHtmlResult,
          'detection.description'
        );
        if (_get(detectionDescription, `i18n.${l}`)) {
          Object.keys(_get(detectionDescription, `i18n.${l}`)).map(
            indicator => {
              if (indicator === 'age_spot') {
                // configDescription.spot = detectionDescription.age_spot;
                configDescription.spot = _get(
                  detectionDescription,
                  `i18n.${l}.age_spot`
                );
              } else if (indicator === 'dark_circle_v2') {
                // configDescription.darkCircle = detectionDescription.dark_circle;
                configDescription.darkCircle = _get(
                  detectionDescription,
                  `i18n.${l}.dark_circle_v2`
                );
              } else {
                // configDescription[indicator] = detectionDescription[indicator];
                configDescription[indicator] = _get(
                  detectionDescription,
                  `i18n.${l}.${indicator}`
                );
              }
            }
          );
        }

        Object.keys(detectionDescription).map(indicator => {
          if (
            [
              'categories',
              'backgroundColor',
              'activeCategory',
              'enable',
              'textColor',
            ].includes(indicator)
          ) {
            configDescription[indicator] = detectionDescription[indicator];
          }
        });
        copySkincareHtmlResult.detection.description = configDescription;

        // convert score to number
        copySkincareHtmlResult.skinHealth.score.avgLowerBound = Number(
          copySkincareHtmlResult.skinHealth.score.avgLowerBound
        );
        copySkincareHtmlResult.skinHealth.score.avgUpperBound = Number(
          copySkincareHtmlResult.skinHealth.score.avgUpperBound
        );
        copySkincareHtmlResult.skinHealth.summary.content = _get(
          copySkincareHtmlResult.skinHealth.summary,
          `contentI18n.${l}`
        );
        copySkincareHtmlResult.detection.score.avgLowerBound = Number(
          copySkincareHtmlResult.detection.score.avgLowerBound
        );
        copySkincareHtmlResult.detection.score.avgUpperBound = Number(
          copySkincareHtmlResult.detection.score.avgUpperBound
        );
        const footerButtons = buttons.map(btn => {
          const words = _get(btn, `textI18n.${l}`, '')
            .replace(/<span>/g, '')
            .replace(/<[/]span>/g, '')
            .replace(/<p>/g, '')
            .replace(/<[/]p>/g, '')
            .replace(/<em>/g, '')
            .replace(/<[/]em>/g, '')
            .replace(/<strong>/g, '')
            .replace(/<[/]strong>/g, '')
            .replace(/<u>/g, '')
            .replace(/<[/]u>/g, '')
            .replace('\n', '')
            .split('>');
          return btn.type === 'getPhoto'
            ? {
                ...btn,
                pureText: _get(words, '[1]', ''),
                text: _get(btn, `textI18n.${l}`, '').replace(
                  'font-size: 24px;',
                  ''
                ),
              }
            : {
                ...btn,
                text: _get(btn, `textI18n.${l}`, '').replace(
                  'font-size: 24px;',
                  ''
                ),
              };
        });

        copySkincareHtmlResult.recommendSummary = {
          enable: false,
          backgroundImage: [
            {
              type: 'mobile',
              url: _get(recommendSummary, 'backgroundImage[0].image') || '',
              image: _get(recommendSummary, 'backgroundImage[0].image') || '',
            },
            {
              type: 'pad',
              url: _get(recommendSummary, 'backgroundImage[1].image') || '',
              image: _get(recommendSummary, 'backgroundImage[1].image') || '',
            },
            {
              type: 'padLandscape',
              url: _get(recommendSummary, 'backgroundImage[2].image') || '',
              image: _get(recommendSummary, 'backgroundImage[2].image') || '',
            },
          ],
          content:
            '<span style="color: ' +
            _get(recommendSummary, `textColor`, '#000000') +
            ';">' +
            _get(recommendSummary, `contentI18n.${l}`, '') +
            '</span>\n',
          textColor: _get(recommendSummary, `textColor`) || '#000000',
          layout: _get(recommendSummary, `layout`, [
            {value: 'routineRecommend'},
            {value: 'productRecommend'},
            {value: 'treatmentRecommend'},
          ]).filter(r => r.disabled === false) || [
            {value: 'routineRecommend'},
            {value: 'productRecommend'},
            {value: 'treatmentRecommend'},
          ],
        };

        copySkincareHtmlResult.routineRecommend = {
          backgroundColor:
            _get(routineRecommend, `backgroundColor`) || '#ebf8ff',
          heading: {
            text:
              '<span style="color: ' +
              _get(
                routineRecommend,
                `heading.block.titleTextColor`,
                '#000000'
              ) +
              ';">' +
              _get(routineRecommend, `heading.textI18n.${l}`) +
              '</span>\n',
            backgroundColor:
              _get(routineRecommend, `backgroundColor`) || '#ebf8ff',
          },
          block: {
            titleTextColor:
              _get(routineRecommend, `heading.block.categoryTextColor`) ||
              '#000000',
            stepTextColor:
              _get(routineRecommend, `heading.block.stepTextColor`) ||
              '#989eb3',
            categoryTextColor:
              _get(routineRecommend, `heading.block.stepTextColor`) ||
              '#494d5d',
            concernTagColor:
              _get(routineRecommend, `heading.block.concernTagsColor`) ||
              '#494d5d',
          },
          enabledInfo: _get(routineRecommend, `enabledInfo`) || [
            'brandName',
            'productName',
            'productDesc',
          ],
          buyButton: {},
          productCard: {
            backgroundColor:
              _get(routineRecommend, `productCard.backgroundColor`) ||
              '#ffffff',
            borderColor:
              _get(routineRecommend, `productCard.borderColor`) || '#494d5d',
            brandNameTextColor:
              _get(routineRecommend, `productCard.brandNameTextColor`) ||
              '#E62D82',
            productNameTextColor:
              _get(routineRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            productDescTextColor:
              _get(routineRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            button: {
              text: '<span style="color: #ffffff;">BUY NOW</span>',
              backgroundColor: '#000000',
              border: {
                width: '0',
                style: 'solid',
                color: '#000000',
                radius: 0,
              },
            },
            moreInfoIconUrl:
              _get(routineRecommend, `productCard.moreInfoIcon.image`) || '',
          },
          productCardPopUp: {
            backgroundColor: '#ffffff',
            imageBorderColor:
              _get(routineRecommend, `productCard.popup.imageBorderColor`) ||
              '#000000',
            brandNameColor:
              _get(routineRecommend, `productCard.popup.brandNameColor`) ||
              '#E62D82',
            productNameColor:
              _get(routineRecommend, `productCard.popup.productNameColor`) ||
              '#000000',
            productDescriptionColor:
              _get(
                routineRecommend,
                `productCard.popup.productDescriptionColor`
              ) || '#000000',
            buttonTextColor:
              _get(routineRecommend, `productCard.popup.buttonColor`) ||
              '#489CE8',
          },
        };

        copySkincareHtmlResult.productRecommend = {
          backgroundColor:
            _get(productRecommend, `backgroundColor`) || '#ffffff',
          heading: {
            text:
              '<span style="color: ' +
              _get(productRecommend, `heading.textColor`, '#000000') +
              ';">' +
              _get(productRecommend, `heading.textI18n.${l}`) +
              '</span>\n',
            backgroundColor:
              _get(productRecommend, `backgroundColor`) || '#ffffff',
            categoryTextColor:
              _get(productRecommend, `heading.categoryTextColor`) || '#000000',
          },
          enabledInfo: _get(productRecommend, `enabledInfo`) || [
            'brandName',
            'productName',
            'productDesc',
          ],
          buyButton: {},
          productCard: {
            backgroundColor:
              _get(productRecommend, `productCard.backgroundColor`) ||
              '#ffffff',
            borderColor:
              _get(productRecommend, `productCard.borderColor`) || '#494d5d',
            brandNameTextColor:
              _get(productRecommend, `productCard.brandNameTextColor`) ||
              '#E62D82',
            productNameTextColor:
              _get(productRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            productDescTextColor:
              _get(productRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            moreInfoIconUrl:
              _get(productRecommend, `productCard.moreInfoIcon.image`) || '',
          },
          productCardPopUp: {
            backgroundColor: '#ffffff',
            imageBorderColor:
              _get(productRecommend, `productCard.popup.imageBorderColor`) ||
              '#000000',
            brandNameColor:
              _get(productRecommend, `productCard.popup.brandNameColor`) ||
              '#E62D82',
            productNameColor:
              _get(productRecommend, `productCard.popup.productNameColor`) ||
              '#000000',
            concernTagColor:
              _get(productRecommend, `productCard.popup.concernTagColor`) ||
              '#737EA9',
            productDescriptionColor:
              _get(
                productRecommend,
                `productCard.popup.productDescriptionColor`
              ) || '#000000',
            buttonTextColor:
              _get(productRecommend, `productCard.popup.buttonColor`) ||
              '#489CE8',
          },
        };

        copySkincareHtmlResult.treatmentRecommend = {
          backgroundColor:
            _get(treatmentRecommend, `backgroundColor`) || '#ffffff',
          heading: {
            text:
              '<span style="color: ' +
              _get(treatmentRecommend, `heading.textColor`, '#000000') +
              ';">' +
              _get(treatmentRecommend, `heading.textI18n.${l}`) +
              '</span>\n',
            backgroundColor:
              _get(treatmentRecommend, `backgroundColor`) || '#ffffff',
            categoryTextColor:
              _get(treatmentRecommend, `heading.categoryTextColor`) ||
              '#000000',
          },
          enabledInfo: _get(treatmentRecommend, `enabledInfo`) || [
            'brandName',
            'productName',
            'productDesc',
          ],
          buyButton: {},
          productCard: {
            backgroundColor:
              _get(treatmentRecommend, `treatmentCard.backgroundColor`) ||
              '#ffffff',
            borderColor:
              _get(treatmentRecommend, `treatmentCard.borderColor`) ||
              '#494d5d',
            brandNameTextColor:
              _get(treatmentRecommend, `treatmentCard.brandNameTextColor`) ||
              '#E62D82',
            productNameTextColor:
              _get(treatmentRecommend, `treatmentCard.productNameTextColor`) ||
              '#000000',
            productDescTextColor:
              _get(treatmentRecommend, `treatmentCard.productNameTextColor`) ||
              '#000000',
            moreInfoIconUrl:
              _get(treatmentRecommend, `treatmentCard.moreInfoIcon.image`) ||
              '',
          },
          productCardPopUp: {
            backgroundColor: '#ffffff',
            imageBorderColor:
              _get(
                treatmentRecommend,
                `treatmentCard.popup.imageBorderColor`
              ) || '#000000',
            brandNameColor:
              _get(treatmentRecommend, `treatmentCard.popup.brandNameColor`) ||
              '#E62D82',
            productNameColor:
              _get(
                treatmentRecommend,
                `treatmentCard.popup.productNameColor`
              ) || '#000000',
            concernTagColor:
              _get(treatmentRecommend, `treatmentCard.popup.concernTagColor`) ||
              '#737EA9',
            productDescriptionColor:
              _get(
                treatmentRecommend,
                `treatmentCard.popup.productDescriptionColor`
              ) || '#000000',
            buttonTextColor:
              _get(treatmentRecommend, `treatmentCard.popup.buttonColor`) ||
              '#489CE8',
          },
        };

        const getSkincareResultPage = {
          templateType: values.pageType,
          languageType: l,
          pageType: 'getSkincareResult',
          priview: config.preview,
          header: {
            backButton: header.backIcon.enabled
              ? {image: getIconUrl(header.backIcon) || ''}
              : '',
            homeButton: header.homeIcon.enabled
              ? {image: getIconUrl(header.homeIcon) || ''}
              : '',
            backgroundColor: header.backgroundColor
              ? header.backgroundColor
              : '#ffffff',
            borderBottom: {
              width: _get(header, 'borderBottom.width', '1px'),
              style: _get(header, 'borderBottom.style', 'solid'),
              color: _get(header, 'borderBottom.color', '#E1E1E1'),
            },
            pageTabs: {
              enable: _get(header, 'topTabs.enable', false),
              backgroundColor: _get(
                header,
                'topTabs.onClick.tabColor',
                '#FFFFFF'
              ),
              unSeletedBackgroundColor: _get(
                header,
                'topTabs.default.tabColor',
                '#CCCCCC'
              ),
              unSeletedTextColor: _get(
                header,
                'topTabs.default.textColor',
                '#D8DFF8'
              ),
              unSeletedTabColor: _get(
                header,
                'topTabs.default.textColor',
                '#D8DFF8'
              ),
              seletedTextColor: _get(
                header,
                'topTabs.onClick.textColor',
                '#55A8F4'
              ),
              seletedTabColor: _get(
                header,
                'topTabs.onClick.textColor',
                '#55A8F4'
              ),
            },
            recommendSummary: {
              enable: _get(recommendSummary, 'enable', true),
              backgroundImage: [
                {
                  type: 'mobile',
                  url: _get(recommendSummary, 'backgroundImage[0].image') || '',
                },
                {
                  type: 'pad',
                  url: _get(recommendSummary, 'backgroundImage[1].image') || '',
                },
                {
                  type: 'padLandscape',
                  url: _get(recommendSummary, 'backgroundImage[2].image') || '',
                },
              ],
              content:
                '<span style="color: ' +
                _get(recommendSummary, `textColor`, '#000000') +
                ';">' +
                _get(recommendSummary, `contentI18n.${l}`, '') +
                '</span>\n',
              contentTextColor:
                _get(recommendSummary, `textColor`) || '#000000',
              concernSelectedTextColor: '#FFFFFF',
              concernUnSelectedTextColor: '#000000',
              concernTextColor: '#000000',
            },
            productFilterTabs: {
              textColor:
                _get(recommendSummary, `tabColor.textColor`) || '#000000',
              backgroundColor:
                _get(recommendSummary, `tabColor.backgroundColor`) ||
                '#FFFFFF70',
              selectedTextColor:
                _get(recommendSummary, `tabColor.selectedTextColor`) ||
                '#ffffff',
              selectedBackgroundColor:
                _get(recommendSummary, `tabColor.selectedBackgroundColor`) ||
                '#00000099',
              disabledTextColor:
                _get(recommendSummary, `tabColor.disabledTextColor`) ||
                '#00000020',
              disabledBackgroundColor:
                _get(recommendSummary, `tabColor.disabledBackgroundColor`) ||
                '#00000020',
              selectedDisabledTextColor:
                _get(recommendSummary, `tabColor.selectedDisabledTextColor`) ||
                '#ffffff40',
              selectedDisabledBackgroundColor:
                _get(
                  recommendSummary,
                  `tabColor.selectedDisabledBackgroundColor`
                ) || '#00000060',
            },
          },
          body: {
            ...copySkincareHtmlResult,
            backgroundColor: _get(body, 'backgroundColor', '#ffffff'),
          },
          footer: {
            buttonLayout: buttonLayout,
            buttons: footerButtons
              .filter(r => r.enable === true)
              .map(btn => {
                const obj = {
                  type: btn.type,
                  button: getButton(btn),
                };
                return obj;
              }),
            backgroundColor: _get(footer, 'backgroundColor', '#ffffff'),
            boxShadowColor: _get(footer, 'boxShadowColor')
              ? hexToRgba(footer.boxShadowColor)
              : 'rgba(151, 151, 151, 0.75)',
            privatePolicy: {
              contentColor: _get(
                footer,
                'privatePolicy.contentColor',
                '#000000'
              ),
              subContentColor: _get(
                footer,
                'privatePolicy.subContentColor',
                '#434343'
              ),
            },
          },
        };
        pages.push(getSkincareResultPage);

        if (values.features.indexOf('getPhoto') !== -1) {
          const photoHeader = featureConfig.getPhoto.header;
          const getPhotoPage = {
            templateType: values.pageType,
            languageType: l,
            pageType: 'getPhoto',
            header: {
              backButton: photoHeader.backIcon.enabled
                ? {image: getIconUrl(photoHeader.backIcon) || ''}
                : '',
              homeButton: photoHeader.homeIcon.enabled
                ? {image: getIconUrl(photoHeader.homeIcon) || ''}
                : '',
              backgroundColor: photoHeader.backgroundColor
                ? photoHeader.backgroundColor
                : '#ffffff',
              borderBottom: {
                width: _get(photoHeader, 'borderBottom.width', '1px'),
                style: _get(photoHeader, 'borderBottom.style', 'solid'),
                color: _get(photoHeader, 'borderBottom.color', '#E1E1E1'),
              },
            },
            body: {
              photoSize: Number(featureConfig.getPhoto.tryOnPhoto.width),
              backgroundColor: _get(
                featureConfig,
                'getPhoto.body.backgroundColor'
              ),
            },
            footer: {
              buttons: [],
            },
          };
          if (featureConfig.getPhoto.qrCode.enabled) {
            const qrDesc = _get(
              featureConfig,
              `getPhoto.qrCode.descI18n.${l}`,
              ''
            );
            // .replace(/<span>/g, '')
            // .replace(/<[/]span>/g, '')
            // .replace(/<p>/g, '')
            // .replace(/<[/]p>/g, '')
            // .split('>');
            getPhotoPage.footer.buttons.push({
              type: 'qrcode',
              title: _get(
                featureConfig,
                `getPhoto.qrCode.title.textI18n.${l}`,
                ''
              ).replace('font-size: 24px;', ''),
              backgroundColor: _get(
                featureConfig,
                'getPhoto.qrCode.title.backgroundColor',
                '#ffffff'
              ),
              description: {
                color: _get(
                  featureConfig,
                  'getPhoto.qrCode.descColor',
                  '#000000'
                ),
                text: qrDesc,
              },
              getPhotoType: values.getPhotoType,
            });
          }
          if (featureConfig.getPhoto.email.enabled) {
            let sendButton = getButton(
              _get(featureConfig, 'getPhoto.email.sendButton')
            );
            sendButton.text =
              _get(sendButton, `textI18n.${l}`) &&
              _get(sendButton, `textI18n.${l}`).replace('font-size: 24px;', '');
            getPhotoPage.footer.buttons.push({
              type: 'email',
              title: _get(
                featureConfig,
                `getPhoto.email.title.textI18n.${l}`,
                ''
              ).replace('font-size: 24px;', ''),
              backgroundColor: _get(
                featureConfig,
                'getPhoto.email.title.backgroundColor',
                '#ffffff'
              ),
              placeholder: _get(
                featureConfig,
                `getPhoto.email.inputFieldI18n.${l}`,
                ''
              )
                .replace(/<span>/g, '')
                .replace(/<[/]span>/g, '')
                .replace(/<p>/g, '')
                .replace(/<[/]p>/g, '')
                .split('>'),
              button: sendButton,
            });
          }
          pages.push(getPhotoPage);
        }
      });
    });
    return {...config, pages};
  },
  toLandingPreview: values => {
    const {header, body, footer} = values;
    const languages = langUtils.getAppLangList();
    const result = {
      languages: languages.map(r => r.value),
      defaultLanguage: 'enu',
      pages: languages.map(l => {
        return {
          templateType: 'skincare',
          languageType: l.value,
          pageType: 'landing',
          header: {
            settingButton: {
              image: _get(header, 'settingButton.image'),
            },
            logo: {image: _get(header, 'logo.image')},
            displayName: _get(header, 'displayName', 'showAll'),
          },
          body: {
            backgroundColor: body.backgroundColor
              ? body.backgroundColor
              : '#FFFFFF',
            banners: [
              {
                deviceType: 'pad',
                images: body.banners[0].images.filter(r => r !== ''),
                autoplayTimeout: body.banners[0].autoplayTimeout * 1000 || 5000,
              },
              {
                deviceType: 'mobile',
                images: body.banners[1].images.filter(r => r !== ''),
                autoplayTimeout: body.banners[1].autoplayTimeout * 1000 || 5000,
              },
              {
                deviceType: 'padLandscape',
                images: _get(body, 'banners[2].images', []).filter(
                  r => r !== ''
                ),
                autoplayTimeout:
                  _get(body, 'banners[2].autoplayTimeout', 5) * 1000,
              },
            ],
          },
          footer: {
            buttons: [
              {
                type: 'skinAnalysis',
                text: _get(footer, `buttons[0].textI18n.${l.value}`),
                backgroundColor: footer.buttons[0].backgroundColor || '#000000',
                border: {
                  width: footer.buttons[0].border.width || '1px',
                  style: footer.buttons[0].border.style || 'solid',
                  color: footer.buttons[0].border.color || '#000000',
                  radius: footer.buttons[0].border.radius || '8',
                },
              },
            ],
          },
        };
      }),
    };
    return result;
  },
  toSimulationPreview: values => {
    if (!_get(values, 'page.page[0]')) {
      return values;
    }
    const resultPage = values.page.page[0];
    const photoPage = values.page.page[1];
    const images = resultPage.smb && resultPage.smb.treatmentImages;
    const desc = langUtils.getAppLangList().map(l => {
      return {
        [`${l.value}`]: treatmentTypes.map(t => {
          return {
            [`${t.value}`]: {
              treatmentDescription: _get(
                resultPage.treatmentDescriptions,
                `${l.value}.${t.value}.treatmentDescription`
              ),
              idealFor: _get(
                resultPage.treatmentDescriptions,
                `${l.value}.${t.value}.idealFor`
              ),
              treatmentImage: {
                image: _get(images, `${t.value}.imageFile`),
                imageUrl: _get(images, `${t.value}.imageFile`),
              },
            },
          };
        }),
      };
    });

    const template = {
      ...values,
      page: {
        ...values.page,
        page: [
          {
            ...resultPage,
            reportBanner: resultPage.reportBanner && {
              ...resultPage.reportBanner,
              mainImage: [
                {
                  type: 'phone',
                  image: resultPage.reportBanner.mainImage[0].imageFile,
                  imageUrl: resultPage.reportBanner.mainImage[0].imageFile,
                },
                {
                  type: 'pad',
                  image: resultPage.reportBanner.mainImage[1].imageFile,
                  imageUrl: resultPage.reportBanner.mainImage[1].imageFile,
                },
                {
                  type: 'padLandscape',
                  image: _get(
                    resultPage,
                    'reportBanner.mainImage[2].imageFile'
                  ),
                  imageUrl: _get(
                    resultPage,
                    'reportBanner.mainImage[2].imageFile'
                  ),
                },
              ],
            },
            desc,
            treatmentDescriptions: {
              ...resultPage.treatmentDescriptions,
              ...desc.reduce((data, current) => {
                data[Object.keys(current)] = current[
                  Object.keys(current)
                ].reduce((d, c) => {
                  d[Object.keys(c)] = c[Object.keys(c)];
                  return d;
                }, {});
                return data;
              }, {}),
            },
          },
          {
            ...photoPage,
          },
        ],
      },
    };

    return template;
  },
  toResultZip: async values => {
    const config = {
      languages: langUtils.getAppLangList().map(r => r.value),
      defaultLanguage: values.langs[0].page.defaultLanguage || 'enu',
      pages: [],
      preview: getPreviewList(
        _get(values, 'langs[0].preview.concernOrder', [])
      ),
    };

    const getIconUrlToBase64 = async icon => {
      const url = _get(icon, 'image.image');
      return isBase64(url) ? await url : await getBase64FromUrl(url);
    };

    const pages = [];
    config.languages.map(l => {
      values.langs.map(async pageByLang => {
        const {
          header,
          body,
          buttonLayout,
          buttons,
          featureConfig,
          footer,
          skincareHtmlResult,
          preview = [],
        } = pageByLang.page;
        if (_isUndefined(skincareHtmlResult) || _isUndefined(buttons))
          return {};
        if (pageByLang.default) config.defaultLanguage = 'enu';
        // if (config.languages.indexOf(lang) === -1) config.languages.push(lang);

        let copySkincareHtmlResult = _cloneDeep(skincareHtmlResult);

        const recommendSummary =
          _get(skincareHtmlResult, 'recommendSummary') || {};
        const routineRecommend =
          _get(skincareHtmlResult, 'routineRecommend') || {};
        const productRecommend =
          _get(skincareHtmlResult, 'productRecommend') || {};
        const treatmentRecommend =
          _get(skincareHtmlResult, 'treatmentRecommend') || {};

        // sync with APP values - spot and darkCircle
        const configDescription = {};
        const detectionDescription = _get(
          skincareHtmlResult,
          'detection.description'
        );
        if (_get(detectionDescription, `i18n.${l}`)) {
          Object.keys(_get(detectionDescription, `i18n.${l}`)).map(
            indicator => {
              if (indicator === 'age_spot') {
                // configDescription.spot = detectionDescription.age_spot;
                configDescription.spot = _get(
                  detectionDescription,
                  `i18n.${l}.age_spot`
                );
              } else if (indicator === 'dark_circle_v2') {
                // configDescription.darkCircle = detectionDescription.dark_circle;
                configDescription.darkCircle = _get(
                  detectionDescription,
                  `i18n.${l}.dark_circle_v2`
                );
              } else {
                // configDescription[indicator] = detectionDescription[indicator];
                configDescription[indicator] = _get(
                  detectionDescription,
                  `i18n.${l}.${indicator}`
                );
              }
            }
          );
        }

        Object.keys(detectionDescription).map(indicator => {
          if (
            [
              'categories',
              'backgroundColor',
              'activeCategory',
              'enable',
              'textColor',
            ].includes(indicator)
          ) {
            configDescription[indicator] = detectionDescription[indicator];
          }
        });
        copySkincareHtmlResult.detection.description = configDescription;

        // convert score to number
        copySkincareHtmlResult.skinHealth.score.avgLowerBound = Number(
          copySkincareHtmlResult.skinHealth.score.avgLowerBound
        );
        copySkincareHtmlResult.skinHealth.score.avgUpperBound = Number(
          copySkincareHtmlResult.skinHealth.score.avgUpperBound
        );
        copySkincareHtmlResult.detection.score.avgLowerBound = Number(
          copySkincareHtmlResult.detection.score.avgLowerBound
        );
        copySkincareHtmlResult.detection.score.avgUpperBound = Number(
          copySkincareHtmlResult.detection.score.avgUpperBound
        );

        copySkincareHtmlResult.skinHealth.summary.content = _get(
          copySkincareHtmlResult.skinHealth.summary,
          `contentI18n.${l}`
        );

        const footerButtons = buttons.map(btn => {
          const words = _get(btn, `textI18n.${l}`, '')
            .replace(/<span>/g, '')
            .replace(/<[/]span>/g, '')
            .replace(/<p>/g, '')
            .replace(/<[/]p>/g, '')
            .replace(/<em>/g, '')
            .replace(/<[/]em>/g, '')
            .replace(/<strong>/g, '')
            .replace(/<[/]strong>/g, '')
            .replace(/<u>/g, '')
            .replace(/<[/]u>/g, '')
            .replace('\n', '')
            .split('>');
          return btn.type === 'getPhoto'
            ? {
                ...btn,
                pureText: _get(words, '[1]', ''),
                text: _get(btn, `textI18n.${l}`, '').replace(
                  'font-size: 24px;',
                  ''
                ),
              }
            : {
                ...btn,
                text: _get(btn, `textI18n.${l}`, '').replace(
                  'font-size: 24px;',
                  ''
                ),
              };
        });

        copySkincareHtmlResult.recommendSummary = {
          enable: false,
          backgroundImage: [
            {
              type: 'mobile',
              url:
                _get(recommendSummary, 'backgroundImage[0].image') !== ''
                  ? './assets/image/result_recommendSummary_backgroundImage_mobile.jpg'
                  : '',
              image:
                _get(recommendSummary, 'backgroundImage[0].image') !== ''
                  ? './assets/image/result_recommendSummary_backgroundImage_mobile.jpg'
                  : '',
            },
            {
              type: 'pad',
              url:
                _get(recommendSummary, 'backgroundImage[1].image') !== ''
                  ? './assets/image/result_recommendSummary_backgroundImage_pad.jpg'
                  : '',
              image:
                _get(recommendSummary, 'backgroundImage[1].image') !== ''
                  ? './assets/image/result_recommendSummary_backgroundImage_pad.jpg'
                  : '',
            },
            {
              type: 'padLandscape',
              url:
                _get(recommendSummary, 'backgroundImage[2].image') !== ''
                  ? './assets/image/result_recommendSummary_backgroundImage_pad.jpg'
                  : '',
              image:
                _get(recommendSummary, 'backgroundImage[2].image') !== ''
                  ? './assets/image/result_recommendSummary_backgroundImage_pad.jpg'
                  : '',
            },
          ],
          content:
            '<span style="color: ' +
            _get(recommendSummary, `textColor`, '#000000') +
            ';">' +
            _get(recommendSummary, `contentI18n.${l}`, '') +
            '</span>\n',
          textColor: _get(recommendSummary, `textColor`) || '#000000',
          layout: (await _get(recommendSummary, `layout`, [
            {value: 'routineRecommend'},
            {value: 'productRecommend'},
            {value: 'treatmentRecommend'},
          ]).filter(async r => (await r.disabled) === false)) || [
            {value: 'routineRecommend'},
            {value: 'productRecommend'},
            {value: 'treatmentRecommend'},
          ],
        };

        copySkincareHtmlResult.routineRecommend = {
          backgroundColor:
            _get(routineRecommend, `backgroundColor`) || '#ebf8ff',
          heading: {
            text:
              '<span style="color: ' +
              _get(
                routineRecommend,
                `heading.block.titleTextColor`,
                '#000000'
              ) +
              ';">' +
              _get(routineRecommend, `heading.textI18n.${l}`) +
              '</span>\n',
            backgroundColor:
              _get(routineRecommend, `backgroundColor`) || '#ebf8ff',
          },
          block: {
            titleTextColor:
              _get(routineRecommend, `heading.block.categoryTextColor`) ||
              '#000000',
            stepTextColor:
              _get(routineRecommend, `heading.block.stepTextColor`) ||
              '#989eb3',
            categoryTextColor:
              _get(routineRecommend, `heading.block.stepTextColor`) ||
              '#494d5d',
            concernTagColor:
              _get(routineRecommend, `heading.block.concernTagsColor`) ||
              '#494d5d',
          },
          enabledInfo: _get(routineRecommend, `enabledInfo`) || [
            'brandName',
            'productName',
            'productDesc',
          ],
          buyButton: {},
          productCard: {
            backgroundColor:
              _get(routineRecommend, `productCard.backgroundColor`) ||
              '#ffffff',
            borderColor:
              _get(routineRecommend, `productCard.borderColor`) || '#494d5d',
            brandNameTextColor:
              _get(routineRecommend, `productCard.brandNameTextColor`) ||
              '#E62D82',
            productNameTextColor:
              _get(routineRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            productDescTextColor:
              _get(routineRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            button: {
              text: '<span style="color: #ffffff;">BUY NOW</span>',
              backgroundColor: '#000000',
              border: {
                width: '0',
                style: 'solid',
                color: '#000000',
                radius: 0,
              },
            },
            moreInfoIconUrl:
              _get(routineRecommend, 'productCard.moreInfoIcon.image') !== ''
                ? './assets/image/result_routineRecommend_productCard_moreInfoIcon.jpg'
                : '',
          },
          productCardPopUp: {
            backgroundColor: '#ffffff',
            imageBorderColor:
              _get(routineRecommend, `productCard.popup.imageBorderColor`) ||
              '#000000',
            brandNameColor:
              _get(routineRecommend, `productCard.popup.brandNameColor`) ||
              '#E62D82',
            productNameColor:
              _get(routineRecommend, `productCard.popup.productNameColor`) ||
              '#000000',
            productDescriptionColor:
              _get(
                routineRecommend,
                `productCard.popup.productDescriptionColor`
              ) || '#000000',
            buttonTextColor:
              _get(routineRecommend, `productCard.popup.buttonColor`) ||
              '#489CE8',
          },
        };

        copySkincareHtmlResult.productRecommend = {
          backgroundColor:
            _get(productRecommend, `backgroundColor`) || '#ffffff',
          heading: {
            text:
              '<span style="color: ' +
              _get(productRecommend, `heading.textColor`, '#000000') +
              ';">' +
              _get(productRecommend, `heading.textI18n.${l}`) +
              '</span>\n',
            backgroundColor:
              _get(productRecommend, `backgroundColor`) || '#ffffff',
            categoryTextColor:
              _get(productRecommend, `heading.categoryTextColor`) || '#000000',
          },
          enabledInfo: _get(productRecommend, `enabledInfo`) || [
            'brandName',
            'productName',
            'productDesc',
          ],
          buyButton: {},
          productCard: {
            backgroundColor:
              _get(productRecommend, `productCard.backgroundColor`) ||
              '#ffffff',
            borderColor:
              _get(productRecommend, `productCard.borderColor`) || '#494d5d',
            brandNameTextColor:
              _get(productRecommend, `productCard.brandNameTextColor`) ||
              '#E62D82',
            productNameTextColor:
              _get(productRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            productDescTextColor:
              _get(productRecommend, `productCard.productNameTextColor`) ||
              '#000000',
            moreInfoIconUrl:
              _get(productRecommend, 'productCard.moreInfoIcon.image') !== ''
                ? './assets/image/result_productRecommend_productCard_moreInfoIcon.jpg'
                : '',
          },
          productCardPopUp: {
            backgroundColor: '#ffffff',
            imageBorderColor:
              _get(productRecommend, `productCard.popup.imageBorderColor`) ||
              '#000000',
            brandNameColor:
              _get(productRecommend, `productCard.popup.brandNameColor`) ||
              '#E62D82',
            productNameColor:
              _get(productRecommend, `productCard.popup.productNameColor`) ||
              '#000000',
            concernTagColor:
              _get(productRecommend, `productCard.popup.concernTagColor`) ||
              '#737EA9',
            productDescriptionColor:
              _get(
                productRecommend,
                `productCard.popup.productDescriptionColor`
              ) || '#000000',
            buttonTextColor:
              _get(productRecommend, `productCard.popup.buttonColor`) ||
              '#489CE8',
          },
        };

        copySkincareHtmlResult.treatmentRecommend = {
          backgroundColor:
            _get(treatmentRecommend, `backgroundColor`) || '#ffffff',
          heading: {
            text:
              '<span style="color: ' +
              _get(treatmentRecommend, `heading.textColor`, '#000000') +
              ';">' +
              _get(treatmentRecommend, `heading.textI18n.${l}`, '') +
              '</span>\n',
            backgroundColor:
              _get(treatmentRecommend, `backgroundColor`) || '#ffffff',
            categoryTextColor:
              _get(treatmentRecommend, `heading.categoryTextColor`) ||
              '#000000',
          },
          enabledInfo: _get(treatmentRecommend, `enabledInfo`) || [
            'brandName',
            'productName',
            'productDesc',
          ],
          buyButton: {},
          productCard: {
            backgroundColor:
              _get(treatmentRecommend, `treatmentCard.backgroundColor`) ||
              '#ffffff',
            borderColor:
              _get(treatmentRecommend, `treatmentCard.borderColor`) ||
              '#494d5d',
            brandNameTextColor:
              _get(treatmentRecommend, `treatmentCard.brandNameTextColor`) ||
              '#E62D82',
            productNameTextColor:
              _get(treatmentRecommend, `treatmentCard.productNameTextColor`) ||
              '#000000',
            productDescTextColor:
              _get(treatmentRecommend, `treatmentCard.productNameTextColor`) ||
              '#000000',
            moreInfoIconUrl:
              _get(treatmentRecommend, 'productCard.moreInfoIcon.image') !== ''
                ? './assets/image/result_treatmentRecommend_productCard_moreInfoIcon.jpg'
                : '',
          },
          productCardPopUp: {
            backgroundColor: '#ffffff',
            imageBorderColor:
              _get(
                treatmentRecommend,
                `treatmentCard.popup.imageBorderColor`
              ) || '#000000',
            brandNameColor:
              _get(treatmentRecommend, `treatmentCard.popup.brandNameColor`) ||
              '#E62D82',
            productNameColor:
              _get(
                treatmentRecommend,
                `treatmentCard.popup.productNameColor`
              ) || '#000000',
            concernTagColor:
              _get(treatmentRecommend, `treatmentCard.popup.concernTagColor`) ||
              '#737EA9',
            productDescriptionColor:
              _get(
                treatmentRecommend,
                `treatmentCard.popup.productDescriptionColor`
              ) || '#000000',
            buttonTextColor:
              _get(treatmentRecommend, `treatmentCard.popup.buttonColor`) ||
              '#489CE8',
          },
        };

        const getSkincareResultPage = {
          templateType: values.pageType,
          languageType: l,
          pageType: 'getSkincareResult',
          priview: config.preview,
          header: {
            backButton: header.backIcon.enabled
              ? {
                  image:
                    _get(header, 'backIcon') !== ''
                      ? './assets/image/result_back.jpg'
                      : '',
                }
              : '',
            homeButton: header.homeIcon.enabled
              ? {
                  image:
                    _get(header, 'homeIcon') !== ''
                      ? './assets/image/result_home.jpg'
                      : '',
                }
              : '',
            backgroundColor: header.backgroundColor
              ? header.backgroundColor
              : '#ffffff',
            borderBottom: {
              width: _get(header, 'borderBottom.width', '1px'),
              style: _get(header, 'borderBottom.style', 'solid'),
              color: _get(header, 'borderBottom.color', '#E1E1E1'),
            },
            pageTabs: {
              enable: _get(header, 'topTabs.enable', false),
              backgroundColor: _get(
                header,
                'topTabs.onClick.tabColor',
                '#FFFFFF'
              ),
              unSeletedBackgroundColor: _get(
                header,
                'topTabs.default.tabColor',
                '#CCCCCC'
              ),
              unSeletedTextColor: _get(
                header,
                'topTabs.default.textColor',
                '#D8DFF8'
              ),
              unSeletedTabColor: _get(
                header,
                'topTabs.default.textColor',
                '#D8DFF8'
              ),
              seletedTextColor: _get(
                header,
                'topTabs.onClick.textColor',
                '#55A8F4'
              ),
              seletedTabColor: _get(
                header,
                'topTabs.onClick.textColor',
                '#55A8F4'
              ),
            },
            recommendSummary: {
              enable: _get(recommendSummary, 'enable', true),
              backgroundImage: [
                {
                  type: 'mobile',
                  url: _get(recommendSummary, 'backgroundImage[0].image') || '',
                },
                {
                  type: 'pad',
                  url: _get(recommendSummary, 'backgroundImage[1].image') || '',
                },
                {
                  type: 'padLandscape',
                  url: _get(recommendSummary, 'backgroundImage[2].image') || '',
                },
              ],
              content: _get(recommendSummary, `contentI18n.${l}`) || '',
              contentTextColor:
                _get(recommendSummary, `textColor`) || '#000000',
              concernSelectedTextColor: '#FFFFFF',
              concernUnSelectedTextColor: '#000000',
              concernTextColor: '#000000',
            },
            productFilterTabs: {
              textColor:
                _get(recommendSummary, `tabColor.textColor`) || '#000000',
              backgroundColor:
                _get(recommendSummary, `tabColor.backgroundColor`) ||
                '#FFFFFF70',
              selectedTextColor:
                _get(recommendSummary, `tabColor.selectedTextColor`) ||
                '#ffffff',
              selectedBackgroundColor:
                _get(recommendSummary, `tabColor.selectedBackgroundColor`) ||
                '#00000099',
              disabledTextColor:
                _get(recommendSummary, `tabColor.disabledTextColor`) ||
                '#00000020',
              disabledBackgroundColor:
                _get(recommendSummary, `tabColor.disabledBackgroundColor`) ||
                '#00000020',
              selectedDisabledTextColor:
                _get(recommendSummary, `tabColor.selectedDisabledTextColor`) ||
                '#ffffff40',
              selectedDisabledBackgroundColor:
                _get(
                  recommendSummary,
                  `tabColor.selectedDisabledBackgroundColor`
                ) || '#00000060',
            },
          },
          body: {
            ...copySkincareHtmlResult,
            backgroundColor: _get(body, 'backgroundColor', '#ffffff'),
          },
          footer: {
            buttonLayout: buttonLayout,
            buttons: footerButtons
              .filter(r => r.enable === true)
              .map(btn => {
                const obj = {
                  type: btn.type,
                  button: getButton(btn),
                };
                return obj;
              }),
            backgroundColor: _get(footer, 'backgroundColor', '#ffffff'),
            boxShadowColor: _get(footer, 'boxShadowColor')
              ? hexToRgba(footer.boxShadowColor)
              : 'rgba(151, 151, 151, 0.75)',
            privatePolicy: {
              contentColor: _get(
                footer,
                'privatePolicy.contentColor',
                '#000000'
              ),
              subContentColor: _get(
                footer,
                'privatePolicy.subContentColor',
                '#434343'
              ),
            },
          },
        };
        pages.push(getSkincareResultPage);

        if (values.features.indexOf('getPhoto') !== -1) {
          const photoHeader = featureConfig.getPhoto.header;
          const getPhotoPage = {
            templateType: values.pageType,
            languageType: l,
            pageType: 'getPhoto',
            header: {
              backButton: photoHeader.backIcon.enabled
                ? {
                    image:
                      _get(photoHeader, 'backIcon') !== ''
                        ? './assets/image/get_result_back.jpg'
                        : '',
                  }
                : '',
              homeButton: photoHeader.homeIcon.enabled
                ? {
                    image:
                      _get(photoHeader, 'homeIcon') !== ''
                        ? './assets/image/get_result_home.jpg'
                        : '',
                  }
                : '',
              backgroundColor: photoHeader.backgroundColor
                ? photoHeader.backgroundColor
                : '#ffffff',
              borderBottom: {
                width: _get(photoHeader, 'borderBottom.width', '1px'),
                style: _get(photoHeader, 'borderBottom.style', 'solid'),
                color: _get(photoHeader, 'borderBottom.color', '#E1E1E1'),
              },
            },
            body: {
              photoSize: Number(featureConfig.getPhoto.tryOnPhoto.width),
              backgroundColor: _get(
                featureConfig,
                'getPhoto.body.backgroundColor'
              ),
            },
            footer: {
              buttons: [],
            },
          };
          if (featureConfig.getPhoto.qrCode.enabled) {
            const qrDesc = _get(
              featureConfig,
              `getPhoto.qrCode.descI18n.${l}`,
              ''
            );
            // .replace(/<span>/g, '')
            // .replace(/<[/]span>/g, '')
            // .replace(/<p>/g, '')
            // .replace(/<[/]p>/g, '')
            // .split('>');
            getPhotoPage.footer.buttons.push({
              type: 'qrcode',
              title: _get(
                featureConfig,
                `getPhoto.qrCode.title.textI18n.${l}`,
                ''
              ).replace('font-size: 24px;', ''),
              backgroundColor: _get(
                featureConfig,
                'getPhoto.qrCode.title.backgroundColor',
                '#ffffff'
              ),
              description: {
                color: _get(
                  featureConfig,
                  'getPhoto.qrCode.descColor',
                  '#000000'
                ),
                text: qrDesc,
              },
              getPhotoType: values.getPhotoType,
            });
          }
          if (featureConfig.getPhoto.email.enabled) {
            let sendButton = getButton(
              _get(featureConfig, 'getPhoto.email.sendButton')
            );
            sendButton.text =
              _get(sendButton, `textI18n.${l}`) &&
              _get(sendButton, `textI18n.${l}`).replace('font-size: 24px;', '');
            getPhotoPage.footer.buttons.push({
              type: 'email',
              title: _get(
                featureConfig,
                `getPhoto.email.title.textI18n.${l}`,
                ''
              ).replace('font-size: 24px;', ''),
              backgroundColor: _get(
                featureConfig,
                'getPhoto.email.title.backgroundColor',
                '#ffffff'
              ),
              placeholder: _get(
                featureConfig,
                `getPhoto.email.inputFieldI18n.${l}`,
                ''
              )
                .replace(/<span>/g, '')
                .replace(/<[/]span>/g, '')
                .replace(/<p>/g, '')
                .replace(/<[/]p>/g, '')
                .split('>'),
              button: sendButton,
            });
          }
          pages.push(getPhotoPage);
        }
      });
    });
    return {...config, pages: pages};
  },
  toLandingZip: async values => {
    const {header, body, footer} = values;
    const languages = langUtils.getAppLangList();

    const padImages = () => {
      return body.banners[0].images.map((r, i) => {
        if (r !== '') {
          return `./assets/image/banner_pad_${i + 1}.jpg`;
        }
        return '';
      });
    };

    const mobileImages = async () => {
      const data = body.banners[1].images.map((r, i) => {
        if (r !== '') {
          return `./assets/image/banner_mobile_${i + 1}.jpg`;
        }
        return '';
      });

      return await Promise.all(data);
    };

    const result = {
      languages: languages.map(r => r.value),
      defaultLanguage: 'enu',
      pages: await Promise.all(
        languages.map(async l => {
          return {
            templateType: 'skincare',
            languageType: l.value,
            pageType: 'landing',
            header: {
              settingButton: {
                image:
                  _get(header, 'settingButton.image') !== ''
                    ? './assets/image/header.jpg'
                    : '',
              },
              logo: {
                image:
                  _get(header, 'logo.image') !== ''
                    ? './assets/image/logo.jpg'
                    : '',
              },
              displayName: _get(header, 'displayName', 'showAll'),
            },
            body: {
              backgroundColor: body.backgroundColor
                ? body.backgroundColor
                : '#FFFFFF',
              banners: [
                {
                  deviceType: 'pad',
                  images: await padImages(),
                  autoplayTimeout:
                    body.banners[0].autoplayTimeout * 1000 || 5000,
                },
                {
                  deviceType: 'mobile',
                  images: await mobileImages(),
                  autoplayTimeout:
                    body.banners[1].autoplayTimeout * 1000 || 5000,
                },
              ],
            },
            footer: {
              buttons: [
                {
                  type: 'skinAnalysis',
                  text: _get(footer, `buttons[0].textI18n.${l.value}`),
                  backgroundColor:
                    footer.buttons[0].backgroundColor || '#000000',
                  border: {
                    width: footer.buttons[0].border.width || '1px',
                    style: footer.buttons[0].border.style || 'solid',
                    color: footer.buttons[0].border.color || '#000000',
                    radius: footer.buttons[0].border.radius || '8',
                  },
                },
              ],
            },
          };
        })
      ),
    };
    return result;
  },
  toCommonZip: async values => {
    const {header} = values;
    return {
      page: [
        {
          ...values,
          mainImage: {
            logo: {
              image:
                _get(header, 'logo.image') !== ''
                  ? './assets/image/logo.jpg'
                  : '',
            },
          },
        },
      ],
    };
  },
  toLandingV2Zip: async values => {
    const getImgPath = (images, name) => {
      return images.map((r, i) => {
        if (r !== '') {
          return `./assets/image/banner_${name}_${i + 1}.jpg`;
        }
        return '';
      });
    };

    return {
      page: [
        {
          ...values,
          mainImage: [
            {
              deviceType: 'pad',
              images: await getImgPath(values.mainImage[0].images, 'pad'),
              autoplayTimeout:
                values.mainImage[0].autoplayTimeout * 1000 || 5000,
            },
            {
              deviceType: 'phone',
              images: await getImgPath(values.mainImage[1].images, 'phone'),
              autoplayTimeout:
                values.mainImage[1].autoplayTimeout * 1000 || 5000,
            },
          ],
        },
      ],
    };
  },
};

function hexToRgba(hex) {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return (
    'rgba(' +
    parseInt(r[1], 16) +
    ',' +
    parseInt(r[2], 16) +
    ',' +
    parseInt(r[3], 16) +
    ',0.75)'
  );
}

// const getBase64FromUrl2 = url => new Promise(resolve => {
//   const image = new Image();
//   image.crossOrigin = 'anonymous';
//   image.onload = () => {
//     const c = document.createElement('canvas');
//     c.width = image.width;
//     c.height = image.height;
//     const ctx = c.getContext('2d');
//     ctx.drawImage(image, 0, 0);
//     resolve(c.toDataURL('imag/png'));
//   }
//   image.onerror = resolve;
//
//   image.src = url;
// })

async function getBase64FromUrl(url) {
  const data = await fetch(url + '?image=' + Math.random());
  const blob = await data.blob();
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
}

function isBase64(str) {
  if (str === '' || str.trim() === '') {
    return false;
  }
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}
